import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmDirective } from './../app.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { notificationTypePipe, SanitizeHtmlPipe, SearchPipe, SeverityPipe, userTypePipe } from './filter-pipe/filter.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddBlockComponent } from './add-block/add-block.component';
import { MaterialModule } from '../material.module';
import { AddEditGroupsComponent } from './add-edit-groups/add-edit-groups.component';
import { AddEditOptionsDialogComponent } from './add-edit-options-dialog/add-edit-options-dialog.component';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { RolePermissionDirective } from '../views/role-permission.directive';
// import { CustomFormsModule } from 'ng2-validation';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { NgDragDropModule } from 'ng-drag-drop';
import { IsValidPasswordDirective } from './Validators/is-valid-password.directive';
import { FormatNamePipe } from './filter-pipe/format-name.pipe';
import { ConfirmationComponent } from '../blogs/confirmation.component';
import { ProductSelectorComponent } from './product-selector/product-selector.component';
// import { SafePipe } from './filter-pipe/safe.pipe';

@NgModule({
  declarations: [FormatNamePipe,
    SearchPipe,
    AddBlockComponent,
    userTypePipe,
    notificationTypePipe,
    AddEditGroupsComponent,
    SeverityPipe,
    AddEditOptionsDialogComponent,
    RolePermissionDirective,
    ConfirmDirective,
    SanitizeHtmlPipe,
    IsValidPasswordDirective,
    ProductSelectorComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ConfirmationPopoverModule.forRoot({}),
    ReactiveFormsModule,
    // CustomFormsModule,
    ConfirmationComponent,
    // NgDragDropModule.forRoot(),
    NgSelectModule

  ],
  exports: [
    FormatNamePipe ,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SearchPipe,
    SanitizeHtmlPipe,
    AddBlockComponent,
    userTypePipe,
    notificationTypePipe,
    AddEditGroupsComponent,
    SeverityPipe,
    AddEditOptionsDialogComponent,
    RolePermissionDirective,
    ConfirmationComponent,
    // CustomFormsModule,
    // NgDragDropModule,
    ConfirmationPopoverModule,
    ConfirmDirective,
    NgSelectModule,
    IsValidPasswordDirective,
    ProductSelectorComponent
  ]
})
export class SharedModule { }
